
<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" [routerLink]="'/companies'">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="m-0">{{'REQUERIMIENTOS.VALIDACION.TITULO' | translate}}</h2>
    </div>
    <!-- / CONTENT HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card" class="center" fxLayout="row wrap">
      <!-- CONTENT -->
      <div style="margin: 20px;" fxFlex="100" fxLayout="row" fxLayoutAlign="start stretch">

        <mat-sidenav-container fxFlex="100">
          <mat-sidenav #sidenav mode="side" [(opened)]="opened">
            <div fxLayout="row" fxLayoutAlign="center stretch" class="">
              <div *ngIf="datosEmp && datosTI" class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch">
                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'REQUERIMIENTOS.VALIDACION.DATOSTI.INFOEMPRESA' | translate}}</h2>
                  <button mat-icon-button (click)="sidenav.toggle()">
                    <mat-icon>arrow_back</mat-icon>
                  </button>
                </div>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.NOMBREEMPRESA' | translate}}</div>
                  <div class="font-size-24 font-weight-300 line-height-1 mt-8 wbba">{{datosEmp.data.nombreEmpresa}}</div>
                </div>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.NOMBRE' | translate}}</div>
                  <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{datosTI.datosTI.nombreTI}}</div>
                </div>
                <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.EMAIL' | translate}}</div>
                  <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{datosTI.datosTI.emailTI}}</div>
                </div>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.TEL' | translate}}</div>
                  <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{datosTI.datosTI.telTI}}</div>
                </div>
                <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.EXT' | translate}}</div>
                  <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{datosTI.datosTI.extTI}}</div>
                </div>
                <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch">
                  <div class="h4 secondary-text">{{'REQUERIMIENTOS.VALIDACION.DATOSTI.CEL' | translate}}</div>
                  <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{datosTI.datosTI.celTI}}</div>
                </div>
              </div>
            </div>
          </mat-sidenav>

          <mat-sidenav-content>
            <div fxLayout="column" fxLayoutAlign="start stretch"  class="p-20">

              <div class="" fxLayout="row" fxLayoutAlign="center">
                <button mat-mini-fab color="accent" *ngIf="!opened" (click)="sidenav.toggle()" class="botonInfo" matTooltip="{{'REQUERIMIENTOS.VALIDACION.DATOSTI.TOOLTIP' | translate}}" matTooltipPosition="right">
                  <mat-icon>info</mat-icon>
                </button>
                <h2>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.TITULO' | translate}}</h2>
              </div>

              <ng-container *ngIf="cargando; else infoCompleta">
                <div fxLayout="column" fxLayoutAlign="space-between center" >
                  <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                  <h1>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.CARGANDO' | translate}}</h1>
                </div>
              </ng-container>

              <ng-template #infoCompleta>
                <div class="" fxLayout="column" fxLayoutAlign="start stretch">
                  <mat-progress-bar mode="determinate" value="{{porcentajeAvance}}"></mat-progress-bar>
                  <h4 class="mt-0 mb-10 midText">{{'REQUERIMIENTOS.VALIDACION.TIMELINE.PROGRESO' | translate}} {{porcentajeAvance}}%</h4>
                </div>


                <mat-horizontal-stepper [linear]="isLinear" (selectionChange)="cambioPosicion($event)" [selectedIndex]="pasoActual" #stepper>

                  <mat-step *ngFor="let paso of datosPasos.pasos; let i = index;" [stepControl]="formGroups[i]">
                    <form [formGroup]="formGroups[i]">
                      <ng-template matStepLabel>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.NOMBRES.'+paso.paso | translate}}</ng-template>

                      <mat-form-field class="invisible">
                        <mat-label>Name</mat-label>
                        <input matInput placeholder="Last name, First name" name="paso{{i}}" formControlName="paso{{i}}" [(ngModel)]="paso.status" required>
                      </mat-form-field>

                      <div class="" fxLayout="row" fxLayoutAlign="start">

                        <div class="p-20" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch">
                          <div *ngIf="paso.status == 1" class="mat-elevation-z3 roundEdge" fxLayout="column" fxLayoutAlign="start stretch">
                            <em>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.STATUS.NOTOK' | translate}}</em>
                            <mat-divider></mat-divider>
                            <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between center">
                              <h2>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.NOMBRES.'+paso.paso | translate}}</h2>
                              <button mat-fab class="undone ml-20" (click)="completaPaso(paso._id, i)" matTooltip="{{'REQUERIMIENTOS.VALIDACION.TIMELINE.STATUS.TOOLTIP' | translate}}" matTooltipPosition="below">
                                <mat-icon>thumb_up</mat-icon>
                              </button>
                            </div>
                          </div>

                          <div *ngIf="paso.status == 2" class="mat-elevation-z3 roundEdge" fxLayout="column" fxLayoutAlign="start stretch">
                            <em>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.STATUS.OK' | translate}}</em>
                            <mat-divider></mat-divider>
                            <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between center">
                              <h2>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.NOMBRES.'+paso.paso | translate}}</h2>
                              <button mat-fab class="done ml-20">
                                <mat-icon>check</mat-icon>
                              </button>
                            </div>
                          </div>

                          <div class="mat-elevation-z3 roundEdge mt-40" fxLayout="column" fxLayoutAlign="start stretch">
                            <em>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.TITULO_1' | translate}}</em>
                            <mat-divider></mat-divider>
                            <div *ngIf="paso.status == 1" fxLayout="column" fxLayoutAlign="start stretch">
                              <mat-form-field>
                                <mat-label>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.INPUT' | translate}}</mat-label>
                                <textarea matInput rows="6" placeholder="{{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.INPUT' | translate}}" name="comentario{{i}}" formControlName="comentario{{i}}"></textarea>
                              </mat-form-field>
                              <button mat-raised-button color="primary" (click)="guardaComentario(i,paso._id)">
                                {{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.ENVIAR' | translate}}
                              </button>
                            </div>
                            <div *ngIf="paso.status == 2">
                              <h3 class="mb-0">{{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.CANNOT' | translate}}</h3>
                            </div>
                          </div>

                        </div>

                        <div class="mat-elevation-z4 p-20 m-20 roundEdge" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch">
                          <em>{{'REQUERIMIENTOS.VALIDACION.TIMELINE.COMENTARIO.TITULO_2' | translate}}</em>
                          <mat-divider></mat-divider>
                          <table mat-table [dataSource]="paso.comentarios">

                            <ng-container matColumnDef="comentario">
                              <td mat-cell *matCellDef="let element" class="p-5"> <em class="fw-100">{{element.fecha | date:'short':'':idiomaActual}}</em><br>{{element.texto}} </td>
                            </ng-container>

                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>

                        </div>

                      </div>

                    </form>
                  </mat-step>

                </mat-horizontal-stepper>
              </ng-template>
            </div>


          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
      <!-- / CONTENT -->
    </div>
  </div>
</div>
